import { Component, OnInit, Output, OnDestroy, ViewChild } from '@angular/core';
import { Reports } from '../_models/Reports';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { PhoneReportsService } from '../services/phone-reports.service';

import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-phone-reports-list',
  templateUrl: './phone-reports-list.component.html',
  styleUrls: ['./phone-reports-list.component.scss']
})
export class PhoneReportsListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<boolean>();
  phoneReportsData: Reports[];
  dataSource = new MatTableDataSource();;
  displayedColumns = ['id', 'date', 'count_of_successfully', 'number_of_ports_checked', 'total_reports'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private timePeriod;

  paginationDetail = new BehaviorSubject(
    {
     length: 10,
     pageIndex: 0,
     pageSize: 10
    });


  selectedItem;

  @Output() currenReports;

  constructor(
    public phoneReports: PhoneReportsService,
  ) { }

  ngOnInit() {
    this.phoneReports.getAllReports();
    this.phoneReports.reportsTracker()
        .pipe(takeUntil(this.destroy$))
        .subscribe((reports: Reports[]) => {
          this.selectedItem = reports['data'][0].id;
          this.phoneReportsData = reports['data'];
          this.currenReports = reports['data'][0].fail_telephone_ports;
          this.dataSource.data = reports['data'];
          this.paginator.length = reports['total'];
          this.paginator.pageIndex = reports['current_page'] - 1;
          this.paginator.pageSize = reports['per_page'];
        });
        this.phoneReports.timePeriod
            .pipe(takeUntil(this.destroy$), debounceTime(300))
            .subscribe(res => {
              this.timePeriod = res;
              if (res.selectAutoDate === -1) {
                this.phoneReports.getAllReports();
              } else {
                this.timePeriod.inputStartDate&&this.timePeriod.inputEndDate&&this.phoneReports.filteringReportsByPeriod(this.timePeriod);
              }
            });
        this.paginationDetail.subscribe(res => {
          const resObj = {
            perPage: res.pageSize,
            page: res.pageIndex + 1
          }
          if (this.timePeriod&&this.timePeriod.inputStartDate&&this.timePeriod.inputEndDate) {
            this.phoneReports.filteringReportsByPeriod({...this.timePeriod, ...resObj});
          } else this.phoneReports.getAllReports(resObj)
        });
        
  }

  onSelect(sessionId: string) {
    this.selectedItem = sessionId;
    this.currenReports = this.phoneReportsData.find(el => el.id === this.selectedItem).fail_telephone_ports;    
  }

  getUpdate(event) {
    this.paginationDetail.next(event);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/phone-reports/phone-reports-list/phone-reports-list.component.ts